<template>
    <div id="enSolution">
            <div class="endowloadDetail-head"
        >
            <img :src="list.pic" alt="" class="banner" ondragstart="return false;" oncontextmenu="return false;">
            <div class="endowloadDetail-description">
                <div class="title">
                    <div class="title-txt">
                        {{list.name}}
                    </div>
                </div>
                 <div class="desc">{{list.description}}</div>
                <div class="endowloadDetail-description-btn flex align-cen">
                    <div class="dowload" @click="openReg">
                        预约产品演示
                    </div>
                </div>
            </div>
        </div>
          <div class="item-gradient">
            <div class="p-lg">
                <i class="icon-al-applicationgroup"></i>
                <h1>{{list.name}}</h1>
                <h3>{{list.description}}</h3>
                    <div class="endowloadDetail-description-btn flex align-cen">
                    <div class="open" @click="openReg">预约产品演示</div>
                </div>
            </div>
        </div>
         <div class="endowloadDetail-contaniner" v-if="list.solutionContentList && list.solutionContentList.length >0" id="nr1" >
          <div class="ace-dbl-nav-channel" :class="{ fixed: isFixed }">
              <div class="mod">
                <div class="inner flex align-cen" :class="{ inner1: list.solutionContentList.length == 1 }">
                <div class="nav-text"
                 v-for="(item,index) in list.solutionContentList"
                :key="index"
                :class="{ active: currentNav == index }"
                @click="toBox(index)"
                >{{item.title}}</div>
                </div>
                </div>
          </div>
            <div class="scene j-content" 
                      v-for="(item,index) in list.solutionContentList"
                    :key="index"
             >
                  <div class="quedior">
                        <h2>{{item.title}}</h2>
                        <div class="subtitle ">{{item.subtitle}}</div>
                       <div v-html="item.content" class="nr" v-if="!$util.isMobile()"></div>
                        <div v-html="item.mobileContent ? item.mobileContent : item.content" class="nr" v-if="$util.isMobile()"></div>
                    </div>
             </div>
         </div>
            <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
            <span class="icon-al-wind-cry"></span>
            <p>暂无数据</p>
        </div>
        <!-- 关联应用 -->
         <div class="fzadmin-module" v-if="$route.query.type !=3 && appGl.length">
               <div class="componenet-wrap">
                关联应用
            </div>
            <div class="inner  flex align-cen">
                <div class="ltr-r"
            v-for="(item,index) in appGl"
                :key="index"
                @click="openApp(item)"
             >
                 <div class="ltr"
                 
            >
                <div class="cardContent">
                    <div class="pic-area">
                        <img :src="item.pic" alt="" ondragstart="return false;" oncontextmenu="return false;">
                    </div>
                    <div class="title">{{item.appName}}</div>
                    <div class="description">{{item.description || '暂无描述'}}</div>
                </div>
            </div>
                </div>
            </div>
         </div>
        <goTop></goTop>
    </div>
</template>
<script>
import { solutionDetail,accountClue} from "@/api/enterprise/index" // 解决方案详情
import LocaStorage from "../../utils/localstorage.js"
import goTop from '@/components/goTop'
import debounce from '../../utils/debounce.js' //防抖
import "../../assets/styles/font.css";
export default {
    name:'enSolution',
    data() {
        return {
            currentNav:0,
            list:{},
            tabPosition:'top',
            isFixed: false,
            isClick:false,
            lotoken:false,
            appGl:[],
            contentTopList:[],
            clcikStatu:false,
        }
    },
    components:{
        goTop
    },
     mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听滑动事件
  },
    created () {
        this.getInfo()
          if(this.$route.query.IsService == 1){
            this.openReg(1)
        }
        this.lotoken = LocaStorage.setAge().get('token1') ? true : false
    },
    methods: {
      // 打开关联应用
        openApp(data){
             const newurl = this.$router.resolve({name: 'endowloadDetail', query: {id: data.appId,type:this.$route.query.type}})
        window.open(newurl.href,'_blank')
        },
        // 打开注册页面
        openReg(){
           if(this.$route.query.type == 1) return this.$util.Notifi('仅支持预览','error','fa-exclamation-circle');
             if(LocaStorage.setAge().get('token1')){
              if(this.clcikStatu){
                     this.$util.Notifi('请勿重新申请！','error','fa-exclamation-circle');
                }else{
                     accountClue({
                solutionId:this.$route.query.id,
                officialType:2
                },'enterprise')
                .then(res =>{
                    if(res.code == 0){
                        this.$util.Notifi('您已预约，请等待工作人员联系您','success','fa-check'); 
                        this.clcikStatu = true
                          if(data){
                            this.$router.replace({ name: 'enSolution', query: { id: this.$route.query.id, type:2, } })
                            }
                    }else{
                         this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                })
                }    
             }else{
                 const newurl = this.$router.resolve({name: 'enLogin', query: {id: this.$route.query.id,type:2,redirectUrl:'enSolution'}})
                 window.open(newurl.href,'_blank')
             }
        },
          // 点击tab
    toBox(index) {
    // 点击滚动到指定的位置，要去掉滚动的过程中因为位置变化带来的效果
      this.isClick = true
      this.currentNav = index
      const DOM = document.querySelectorAll('.j-content')[index]
      const offsetTop = DOM.offsetTop - 50
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
       // 过一段时间，把isClick还原
      setTimeout(() => {
        this.isClick = false
      }, 800)
    },
            // 处理滚动
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var offsetTop 
      offsetTop = document.querySelector('.banner').offsetHeight
    //   if(this.$route.query.type == 3) offsetTop = 0
       // 获取所有锚点元素
      const divs = [...document.querySelectorAll('.j-content')]
      // 将所有锚点元素offsetTop push到数组内
      divs.forEach((item, index) => {
        this.contentTopList[index] = item.offsetTop - 50
        
      })
       // 判断当前是否是点击定位的，如果不是，才有滚动定位的效果
      if (!this.isClick) {
        let navIndex
        // 滚动定位tab高亮的状态
        for (let i = 0; i < this.contentTopList.length; i++) {
          // 如果当前滚动的top坐标大于第i个的top坐标，就记录下i。记录到最后，i就会是最后一个满足条件的i，也就是刚刚好的那个值
          if (scrollTop >= this.contentTopList[i]) {
            navIndex = i
          }
        }
        // 把下标赋值给 vue 的 data
        console.log(navIndex)
        this.currentNav = navIndex
        if (typeof navIndex !== 'number') {
           this.currentNav = 0
        }
      }
      // 吸顶效果
        if (scrollTop > offsetTop) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
                  //防抖触发
        debounce(() => {
            this.$bus.$emit("fixedState",this.isFixed);
        }, 300)
         
    },
        // 获取详情
         getInfo(){
              solutionDetail({
                id:this.$route.query.id,
            },'enterprise')
            .then(res => {
                if(res.code == 1) return this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
              res.code == 0 ?  this.list = res.data : this.list = {}
              this.appGl = res.data.appList
              document.title= res.data.name
                 this.$nextTick(function(){
                 const imgDomArray = document.getElementById('nr1')
             imgDomArray.setAttribute('ondragstart','return false')
             imgDomArray.setAttribute('oncontextmenu','return false')
              })
            })
            .catch(err => {

            })
        },
    },
      destroyed() {
    window.removeEventListener('scroll', this.handleScroll) // 销毁监听滑动事件
  },
}
</script>
<style lang="scss" scoped>
#enSolution{
     .item-gradient{
        display: none;
    }
        .fzadmin-module{
      background-color:#f4f4f4;
      .componenet-wrap{
        padding: 50px 0 10px;
        text-align: center;
        font-size: 32px;
            color: #181818;
            max-width: 1280px;
            margin: 0 auto;
            font-weight: bold;
      }
      .inner{
        width: 1280px;
        padding-top: 20px;
        margin: 0 auto;
        padding-bottom: 50px;
        flex-wrap: wrap;
        .ltr-r{
            margin-left: -10px;
            padding-left: 10px;
             padding-right: 10px;
             margin-bottom: 20px;
             cursor: pointer;
             width: 32%;
             .cardContent{
                background: #fff;
                border: 1px solid #ededed;
                overflow: hidden;
            padding-bottom: 20px;
            
            .pic-area{
                overflow: hidden;
                 position: relative;
                 img{
                  height: 175px;
                    max-height: 175px;
                    width: 100%;
                     object-fit: cover;
                 }
            }
            .title{
                height: 24px;
            line-height: 24px;
            padding: 0 20px;
            font-size: 16px;
            color: #181818;
            font-weight: 500;
            overflow: hidden;
            margin-top: 20px;
            margin-bottom: 8px;
            }
            .description{
                color: #3d3d3d;
                line-height: 24px;
                padding: 0 20px;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                padding-bottom: 20px;
            }
             }
             .cardContent:hover{
                box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
    transition: all .3s;
             }
        }
      }
    }
        .endowloadDetail-head{
        position: relative;
        // background-size: cover;
        img{
        position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    object-fit: cover;
        }
        .endowloadDetail-description{
         max-width: 1280px;
         margin: 0 auto;
        padding-top: 16px;
               min-height: 560px;
               position: relative;
               z-index: 1;
         .title{
             margin-top: 180px;
             font-size: 0;
             .title-txt{
                display: inline-block;
                vertical-align: middle;
                font-size: 36px;
                line-height: 48px;
                color: #323233;
             }
         }
          .desc{
            margin-top: 10px;
            line-height: 24px;
            max-height: 72px;
            overflow: hidden;
            width: 60%;
            color: #323233;
              overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          font-size: 16px;
          }
            .endowloadDetail-description-btn{
                margin-top: 40px;
                div{
                  width: 138px;
    cursor: pointer;
    border: none;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    text-align: center;
    vertical-align: middle;
    background-color: #2893f1;
    border-radius: 1px;
    margin-right: 20px;
    padding: 0px 0;
    color: #fff;

                }
            }
        }
    }
}
@media (max-width: 640px){
     .endowloadDetail-description{
        display: none;
    }
      .fzadmin-module{
        .inner{
             width: 100% !important
        }
        .ltr-r{
            width: 90% !important;
            margin: 0 auto;
            margin-left: auto !important;
        }
    }
         .banner{
        position: relative !important;
    width: 100%;
   
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    object-fit: cover;
        }
       .item-gradient{
        padding: 10px;
          display: block !important;
          margin-top: 20px;
          
       .p-lg{
        background: #FAFAFA;
       border-radius: 10px;
        transition: all .3s;
        padding: 30px;
        text-align: center;
        border:1px solid  #D0D0D0;
        i{
            color: #000;
            font-size: 40px;
        }
         .endowloadDetail-description-btn{
            justify-content: space-evenly;;
                div{
                     min-width: 140px;
                    cursor: pointer;
                    border: none;
                    box-shadow: inset 0 0 1px 1px #000000;
                    font-weight: 400;
                    font-size: 15px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: transparent;
                    border-radius: 10px;
                   margin-top: 10px;
                    padding: 5px 0;
                    a{
                        color: #000;
                    }
                }
              
                 div:hover{
                    background: linear-gradient(230.47deg, #FFA41C -0.87%, #FE4141 25.89%, #F4153E 77.87%, #FF27C3 97.94%), #E73828;
                    font-weight: 700;
                    box-shadow: none;
                    color: #fff;
                    
                 }
            }
       }
    }
}
</style>